<template>
  <div class="bg-gradient-to-r from-[#0d4169] to-[#0d4169] min-h-screen w-full flex flex-col md:flex-row">
    <div class="w-full md:w-1/2 flex items-center justify-center p-6 md:p-4">
      <div class="text-white max-w-lg text-center">
        <!-- <img width="260" height="130" src="../assets/logo.png" alt="Ahun Jobs" class="mx-auto brightness-0 invert" /> -->
        <h1 class="text-2xl md:text-3xl font-extrabold mt-6">Ahun Jobs</h1>
        <p class="mt-2 text-sm text-white/80">Admin approval console</p>
      </div>
    </div>

    <div class="w-full md:w-1/2 flex items-center justify-center p-6 md:p-10">
      <div class="w-full max-w-xs bg-white/80 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20">
        <h2 class="text-xl font-extrabold text-gray-800 mb-6 text-center">Admin Login</h2>

        <form class="space-y-4" @submit.prevent="handleSubmit">
          <div class="flex flex-col gap-1">
            <label class="field-label">Username</label>
            <input v-model.trim="form.username" type="text" class="input-field" placeholder="Enter username" required />
          </div>
          <div class="flex flex-col gap-1">
            <label class="field-label">Password</label>
            <input v-model.trim="form.password" type="password" class="input-field" placeholder="Enter password" required />
          </div>

          <p v-if="error" class="text-red-500 text-xs text-center">{{ error }}</p>
          <p v-if="sessionExpired" class="text-amber-600 text-xs text-center">Session expired. Please log in again.</p>

          <button type="submit" class="w-full py-2 bg-[#0d4169] hover:bg-[#0a3354] disabled:opacity-50 text-white font-bold rounded-lg shadow-md transition text-sm" :disabled="loading">
            {{ loading ? 'Signing in…' : 'Login' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'LoginView',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const form = reactive({ username: '', password: '' })
    const loading = ref(false)
    const error = ref('')
    const sessionExpired = computed(() => route.query.session === 'expired')

    async function handleSubmit() {
      error.value = ''
      loading.value = true
      try {
        await store.dispatch('login', form)
        localStorage.setItem('Ahun_last_activity', String(Date.now()))
        router.push({ name: 'dashboard' })
      } catch (err) {
        error.value = err.message || 'Login failed'
      } finally {
        loading.value = false
      }
    }

    return { form, loading, error, sessionExpired, handleSubmit }
  },
}
</script>
